export enum SubscriptionSize {
	G250 = "G250",
	G250x2 = "G250x2",
	Kg1 = "Kg1",
}
